var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgModuleData(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50.09 38.68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".prefix__mod-data-1{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:2.09px}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "prefix__Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "prefix__Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__mod-data-1",
    d: "M25 34.21V5.63A38.51 38.51 0 005.62 1.06v28.57s11.54.62 19.38 4.58zM25 34.21V5.63a38.57 38.57 0 0119.47-4.57v28.57s-11.54.62-19.47 4.58z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "prefix__mod-data-1",
    d: "M5.62 5.63H1.04v29.72h19.43v2.28h9.15v-2.28h19.42V5.63h-4.57"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgModuleData);
export default __webpack_public_path__ + "static/media/module-data.261f226d.svg";
export { ForwardRef as ReactComponent };